module.exports = __webpack_public_path__ + "static/media/sonnensegel.a66a0458.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sonnensegel.jpeg
// module id = 105
// module chunks = 0